module.exports = __webpack_public_path__ + "static/storyBG.6566a811.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/storyBG.jpg
// module id = 227
// module chunks = 21571696733600 278046050153039